import type { ButtonHTMLAttributes } from 'react'

interface ToggleProps
  extends Omit<
    ButtonHTMLAttributes<HTMLButtonElement>,
    'onChange' | 'onClick'
  > {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  id?: string
  className?: string
}

export function Toggle({
  checked,
  onChange,
  label,
  id,
  className = '',
  ...props
}: ToggleProps) {
  return (
    <button
      id={id}
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`w-full flex items-center justify-between py-3 border-b border-[rgba(128,128,128,0.12)] focus:outline-none focus:ring-2 group ${className}`}
      {...props}
    >
      <span className="text-[13px] font-semibold tracking-[0.02em] text-ink dark:text-dark-ink transition-colors text-left">
        {label}
      </span>
      <span
        className={`relative inline-flex h-5 w-9 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out ${
          checked
            ? 'bg-ink dark:bg-dark-ink'
            : 'bg-ink/20 dark:bg-dark-border/40'
        }`}
      >
        <span
          className={`pointer-events-none inline-block h-4 w-4 rounded-full bg-surface dark:bg-dark-bg shadow transform transition ease-in-out duration-200 ${
            checked ? 'translate-x-4' : 'translate-x-0'
          }`}
        />
      </span>
    </button>
  )
}
